const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const IAPAdd = () => import(/* webpackChunkName: "iap" */ '@/modules/iap/view/add.vue');
const IAPClone = () => import(/* webpackChunkName: "iap" */ '@/modules/iap/view/clone.vue');
const IAPEdit = () => import(/* webpackChunkName: "iap" */ '@/modules/iap/view/edit.vue');
const IAPList = () => import(/* webpackChunkName: "iap" */ '@/modules/iap/view/index.vue');

export const ROUTE_NAME_IAP = {
    INDEX: 'IAPList',
    ADD: 'IAPAdd',
    EDIT: 'IAPEdit',
    CLONE: 'IAPClone'
} as const;

export default [
    {
        path: '/app/:appId/iap',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_IAP.INDEX,
                component: IAPList,
                meta: { requiresAuth: true }
            },
            {
                path: ':id',
                name: ROUTE_NAME_IAP.EDIT,
                component: IAPEdit,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_IAP.ADD,
                component: IAPAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/clone',
                name: ROUTE_NAME_IAP.CLONE,
                component: IAPClone,
                meta: { requiresAuth: true }
            }
        ]
    }
];
